import type { CMSConfig } from '#types/config/components/cms'

export default {
  cinemaMode: {
    minWidth: 1440,
    maxHeight: '50vh'
  }
} satisfies CMSConfig['imageBanner']
